var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v-icon",class:'v-icon-' + _vm.icon,style:(_vm.css)})
}
var staticRenderFns = []

export { render, staticRenderFns }